// extracted by mini-css-extract-plugin
export default {"tabs":"RTabs_tabs__mYSCf","scroller":"RTabs_scroller__gLspT","tab":"RTabs_tab__QHWP+","active_tab":"RTabs_active_tab__tNYZl","indicator":"RTabs_indicator__gVkvN"};